// extracted by mini-css-extract-plugin
module.exports = {"accordion__list":"accordion__list"};